export const GET_INVOICE_ITEMS = "GET_INVOICE_ITEMS";
export const GET_INVOICE_ITEM_BY_ID = "GET_INVOICE_ITEM_BY_ID";
export const UPDATE_INVOICE_ITEM = "UPDATE_INVOICE_ITEM";
export const DELETE_INVOICE_ITEM = "DELETE_INVOICE_ITEM";
export const CREATE_INVOICE_ITEM = "CREATE_INVOICE_ITEM";
